export const validateNonNegative = (_, value) => {
  if (value === undefined || value === null) {
    return Promise.resolve();
  }
  return value >= 0
    ? Promise.resolve()
    : Promise.reject(new Error('Negative Value'));
};
